import { z } from 'zod';
import { c } from '../../contract';

export const contentEngagementRouter = c.router(
  {
    getMetrics: {
      summary: 'Get amount of episodes read/stories interacted with in last 30 days',
      method: 'GET',
      path: '',
      responses: {
        200: z.object({
          stories: z.number(),
          chapters: z.number(),
        }),
      },
    },
    updateMetrics: {
      summary: 'Trigger an update of content engagement metrics per user',
      method: 'POST',
      path: '/update',
      body: c.noBody(),
      responses: {
        200: z.object({
          success: z.boolean(),
        }),
      },
    },
    getDataFeedByUserId: {
      summary: 'Get data feed for a userId for iterable',
      method: 'GET',
      path: '/iterable',
      query: z.object({
        userId: z.string(),
      }),
      responses: {
        200: z.object({
          stories: z.number(),
          chapters: z.number(),
        }),
      },
    },
    getMostReadStoryInfo: {
      summary: 'Get data feed for a userId for iterable',
      method: 'GET',
      path: '/most-read-story',
      query: z.object({
        authorId: z.string(),
        userId: z.string(),
        language: z.string(),
      }),
      responses: {
        200: z
          .object({
            storyId: z.string(),
            storyTitle: z.string(),
            authorName: z.string(),
          })
          .nullable(),
      },
    },
  },
  {
    pathPrefix: '/content-engagement',
  },
);
